<template>
  <div id="tac-payrecon-batch" class="tac-admin-payment-reconciliation">
    <div class="page-header">
      <h1 class="page-header-title">
        <span class="fa fa-fw fa-check-square-o"></span>
        {{ title }}
      </h1>
      <div class="page-header-actions page-header-actions--right-position">
        <div class="form-inline form-inline--better-spaced form-inline--compact form-inline--one-liner search-batch">
          <div class="form-group form-group-sm search-batch__number">
            <label class="control-label sr-only">Batch #</label>
            <input class="form-control input-sm text-center" type="text" placeholder="Batch Number" autocomplete="off" v-model="searchForm.batchNumber" @keyup.enter="search()" :disabled="isBusy" />
          </div>
          <div class="form-group form-group-sm search-batch__date-from">
            <label class="control-label sr-only">Date From</label>
            <div class="input-group input-group-sm">
              <flat-pickr v-model="searchForm.startDate" class="form-control" :config="flatPickrConfig" placeholder="Start Date" @keyup.enter="search()" :disabled="isBusy"></flat-pickr>
              <span class="input-group-btn">
                <button type="button" class="btn btn-default" data-toggle :disabled="isBusy">
                  <i class="glyphicon glyphicon-calendar"></i>
                </button>
              </span>
            </div>
          </div>
          <div class="form-group form-group-sm search-batch__date-to">
            <label class="control-label sr-only">Date To</label>
            <div class="input-group input-group-sm">
              <flat-pickr v-model="searchForm.endDate" class="form-control" :config="flatPickrConfig" placeholder="End Date" @keyup.enter="search()" :disabled="isBusy"></flat-pickr>
              <span class="input-group-btn">
                <button type="button" class="btn btn-default" data-toggle :disabled="isBusy">
                  <i class="glyphicon glyphicon-calendar"></i>
                </button>
              </span>
            </div>
          </div>
          <div class="form-group form-group-sm search-batch__actions">
            <div class="btn-toolbar">
              <div class="btn-group">
                <button class="btn btn-default btn-sm" @click="search()" :disabled="isBusy">Find</button>
              </div>
              <div class="btn-group">
                <button class="btn btn-default btn-sm" onclick="window.print();" :disabled="isBusy">Print</button>
              </div>
              <div class="btn-group">
                <a class="btn btn-default btn-sm" :class="{disabled: !previousBatchNumber || isBusy}" :disabled="!previousBatchNumber" @click="previous">Prev</a>
              </div>
              <div class="btn-group">
                <a class="btn btn-default btn-sm" :class="{disabled: !nextBatchNumber || isBusy}" :disabled="!nextBatchNumber" @click="next">Next</a>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-inline__divider"></div>
          </div>
          <div class="form-group">
            <div class="btn-toolbar">
              <div class="btn-group">
                <button type="button" class="btn btn-default btn-sm" @click="reload" title="Reload content" :disabled="isBusy"><i class="fa fa-fw fa-refresh"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p v-if="ledgerNotFound && !batchNumber" class="text-center text-danger">
      Deposit record with accounting transaction ID of {{ ledgerNotFound }} was not found!
    </p>
    <router-view />
    <vue-progress-bar></vue-progress-bar>
  </div><!-- #tac-payrecon-batch -->
</template>

<script>
  import _ from 'lodash'
  import { mapState } from 'vuex'
  import flatPickrConfig from '@/config/flat-pickr'
  import ApiResponseMixin from '@/plugin/mixin/api-response'
  import AuthMixin from '@/plugin/mixin/auth'
  import FormMixin from '@/plugin/mixin/form'

  export default {
    data() {
      return {
        searchForm: {
          batchNumber: null,
          startDate: null,
          endDate: null,
        },
        flatPickrConfig,
        ledgerNotFound: null
      }
    },
    created() {
      if (_.has(this.$route, 'query.ledger-not-found')) {
        this.ledgerNotFound = _.get(this.$route, 'query.ledger-not-found')
      }

      this.$store.commit('paymentReconciliation/batch/setBatchNumber', this.$route.params.batchNumber)
      this.initSearchForm()
      this.fetch()
    },
    watch: {
      title() {
        this.$store.dispatch('app/changeTitle', this.title)
      },
      '$route.params.batchNumber'(val) {
        this.$store.commit('paymentReconciliation/batch/setBatchNumber', val)
      },
      '$route'() {
        this.initSearchForm()
      },
      batchNumber() {
        this.fetch()
      },
      'searchForm.batchNumber'(val) {
        if (!val) {
          return
        }
        this.searchForm.startDate = null
        this.searchForm.endDate = null
      },
      'searchForm.endDate'(val) {
        if (!val) {
          return
        }
        if (!this.searchForm.startDate) {
          return
        }
        this.searchForm.batchNumber = ''
      }
    },
    computed: {
      ...mapState('paymentReconciliation/batch', {
        batchNumber: 'batchNumber',
        nextBatchNumber: 'nextBatchNumber',
        previousBatchNumber: 'previousBatchNumber',
        fetching: 'fetching'
      }),
      title() {
        if ('admin/payment-reconcile/index' == this.$route.name) {
          return 'Payment Reconciliation'
        }
        if ('admin/payment-reconcile/search' == this.$route.name) {
          return 'Payment Reconciliation - Search'
        }
        if ('admin/payment-reconcile/batch' == this.$route.name) {
          return `Reconcile Batch #${this.batchNumber}`
        }
        return ''
      },
      isBusy() {
        return this.fetching
      }
    },
    methods: {
      initSearchForm() {
        this.searchForm.batchNumber = _.get(this.$route, 'query.batchNumber') || this.batchNumber
        this.searchForm.startDate = _.get(this.$route, 'query.startDate')
        this.searchForm.endDate = _.get(this.$route, 'query.endDate')
      },
      reload() {
        this.fetch()
      },
      fetch() {
        this.$store.dispatch('paymentReconciliation/batch/fetch')
      },
      previous() {
        if (!this.previousBatchNumber) {
          return
        }
        this.$router.push({
          name: 'admin/payment-reconcile/batch',
          params: {
            batchNumber: this.previousBatchNumber
          }
        })
      },
      next() {
        if (!this.nextBatchNumber) {
          return
        }
        this.$router.push({
          name: 'admin/payment-reconcile/batch',
          params: {
            batchNumber: this.nextBatchNumber
          }
        })
      },
      search() {
        if (this.searchForm.batchNumber) {
          this.$router.push({
            name: 'admin/payment-reconcile/batch',
            params: {
              batchNumber: this.searchForm.batchNumber
            }
          })
          return
        }

        this.$router.push({
          name: 'admin/payment-reconcile/search',
          query: _.chain(this.searchForm).assign({}).omit(['batchNumber']).value()
        })
      }
    },
    mixins: [
      ApiResponseMixin,
      AuthMixin,
      FormMixin
    ]
  }
</script>
